export default {
  /**
   * URL参数转对象
   * @param url
   */
  queryURL(url) {
    var arr1 = url.split('?')
    var params = arr1[1].split('&')// 进行分割成数组
    var obj = {}// 声明对象
    for (var i = 0; i < params.length; i++) {
      var param = params[i].split('=')// 进行分割成数组
      obj[param[0]] = param[1]// 为对象赋值
    }
    return obj
  },

  /**
   * 将js对象转换成url参数
   * @param obj
   * @returns {string}
   */
  urlencode(obj) {
    var _result = []
    for (var key in obj) {
      var value = obj[key]
      if (Array.isArray(value)) {
        value.forEach(function(_value) {
          _result.push(key + '=' + encodeURIComponent(_value))
        })
      } else {
        _result.push(key + '=' + encodeURIComponent(value))
      }
    }
    return _result.join('&')
  },

  isObjFn(o) {
    if (typeof o === 'string' && o.length) {
      return true
    }

    return Object.prototype.toString.call(o) === '[object Object]'
  },

  /**
   * 是否是有效的JSON
   * @param obj
   * @returns {boolean}
   */
  isValidJSON(obj) {
    try {
      JSON.parse(obj)
      return true
    } catch (e) {
      return false
    }
  },

  /**
   * 验证数字，且最多只能有两位小数
   * @param val
   * @returns {boolean}
   */
  isMoney(val) {
    // let reg = /^\d+(\.\d{1,2})?$/;
    const reg = /^(\d{0,12})(\.(\d{0,4}))?$/g
    return reg.test(val)
  },
  isInterRest(val) {
    const reg = /^(\d{0,6})(\.(\d{0,2}))?$/g
    return reg.test(val)
  },

  // 数字补位 且最多x位
  convertNum(value, sliceNum) {
    if (!value) {
      return ''
    }
    const parseFloatVal = parseFloat(value)
    if (parseFloatVal === 0) {
      return '0.00'
    }
    if (parseFloatVal) {
      const valueNew = parseFloatVal.toString()
      let intPart
      if (Number(valueNew) >= 0) {
        intPart = Math.floor(Number(valueNew)) // 获取整数部分
      } else if (Number(valueNew) < 0) {
        intPart = Math.ceil(Number(valueNew)) // 获取整数部分
      }
      const intPartFormat = intPart.toString()
      let floatPart = '.00' // 预定义小数部分
      // 数组分割出小数部分和整数部分
      const value2Array = valueNew.split('.')
      // 如果有小数位
      if (value2Array[1] && value2Array[1].length > 0) {
        floatPart = value2Array[1] // 拿到小数部分  此处是字符串
        if (floatPart.length === 1) {
          return intPartFormat + '.' + floatPart + '0'
        } else {
          return intPartFormat + '.' + floatPart.slice(0, sliceNum)
        }
      } else { // 如果没有小数位则补0
        return intPartFormat + floatPart
      }
    }
  },
  /* -----------------------------localStorage------------------------------------ */

  /*
   * set localStorage
   */
  setStorage(name, content) {
    if (!name) return
    if (typeof content !== 'string') {
      content = JSON.stringify(content)
    }
    window.localStorage.setItem(name, content)
  },

  /**
   * get localStorage
   */
  getStorage(name) {
    if (!name) return
    const content = window.localStorage.getItem(name)
    return JSON.parse(content)
  },

  /**
   * delete localStorage
   */
  removeStorage(name) {
    if (!name) return
    window.localStorage.removeItem(name)
  },

  /**
   * 文件下载地址
   * @param fileCode 当前文件 fileCode
   */
  downloadFile(fileCode) {
    return '//zb-api.zma-smart.com/ctb/downInterFlowFile?' + this.urlencode({ businessCode: 0, businessType: 0, fileCode: fileCode })
  },

  /**
   * 验证数字输入
   * @param value 当前数值
   * @param floatNum   保留小数位数
   * @param intNum   保留整数位数
   * @param type   0-正数  1-负数
   * @returns {value}
   */
  dealNumber(value, floatNum = 4, intNum = 12, type = 0) {
    if (!value) {
      return ''
    }
    value = value.toString()
    value = value.replace(/^0*(0\.|[1-9])/, '$1')
    if (type === 1) {
      value = value.replace(/[^\d.-]/g, '') // 清除"数字"和"."及"-"以外的字符
    } else {
      value = value.replace(/[^\d.]/g, '') // 清除"数字"和"."及"-"以外的字符
    }
    value = value.replace(/^\./g, '') // 验证第一个字符是数字而不是字符
    value = value.replace(/\.{1,}/g, '.') // 只保留第一个.清除多余的
    value = value
      .replace('.', '$#$')
      .replace(/\./g, '')
      .replace('$#$', '.')
    // value = value.replace(/^(\-)*(\d*)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数

    const iniLength = type === 1 ? intNum + 1 : intNum
    value =
      value.indexOf('.') > 0
        ? value.split('.')[0].substring(0, iniLength) + '.' + value.split('.')[1].substring(0, floatNum)
        : value.substring(0, intNum)
    return value
  }

}
